import { newE2EPage } from "@stencil/core/testing";

describe("country-icon", () => {
    it("should render correct flag img and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-country-icon country="BR"></ux-country-icon>`
        );
        const el = await page.find("ux-country-icon");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render the country as text if an invalid country is passed in", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-country-icon country="ABC"></ux-country-icon>`
        );
        const el = await page.find("ux-country-icon");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });
});
